import {EntityType} from "../../gd/const/item";
import ModelEntity from "../model-entity";
import {ALPHABET_COLORS} from "../../gd/skin/aphabet-colors";
import {convertLetterToColorNumber} from "../../gd/convert/letter-to-color-number";

export default class User extends ModelEntity {

    // public id           : ID
    public name         : string
    public avatar       : string    // ???
    public icon?        : string    // icon file name ?

    public color        : number

    constructor(data: any) {

        super(data.id, EntityType.USER)

        // super(data);

        this.name           = _.get(data,'name')
        this.icon           = _.get(data,'icon')
        this.avatar         = _.get(data,'avatar')

        this.color          = convertLetterToColorNumber(this.colorLetter)

    }

    // still used somewhere like icon user old...
    get initials():string {
        return gd.utils.initials(this.name, 2)
    }

    get iconNormal():string {
        if (!this.icon) this.icon = '_def.jpeg';
        return "/media/user/norm/"+this.icon;
    }

    get iconLarge():string {
        if (!this.icon) this.icon = '_def.jpeg';
        return "/media/user/large/"+this.icon;
    }

    get iconSmall():string {
        if (!this.icon) this.icon = '_def.jpeg';
        return "/media/user/norm/"+this.icon;
    }



    // get color():number {
    //     return gd.utils.nameColor(this.name);
    // }

    private get colorLetter() {
        let letter = gd.utils.initials(this.name, 1).toLowerCase();

        // make sure letter is good and exists in alhabet else "a"
        // @ts-ignore
        letter = ALPHABET_COLORS[letter] ? letter : "a"

        return letter
    }

    public quickSearch(quickSearchValue: string): boolean {
        return this.name.toLowerCase().includes(quickSearchValue.toLowerCase())
    }


    toJSON() {
        return {
            id      : this.id,
            name    : this.name,
            avatar  : this.avatar,
            icon    : this.icon,
            color   : this.color,
        }
    }
}
